<template lang="pug">
#waiter-list-download
  .box
    .box-header.with-border
      .d-flex.justify-content-start.align-items-center
        .d-flex.justify-content-start.flex-column
          .title
            span 待機者のダウンロード

    .box-body.register-body
      .message-container(v-if="!existApplicationTemplateId")
        .warning-message
          div 入所申込み様式が設定されていないため、ダウンロードできません。
          div 設定をご確認ください。
        .mb-4
      .message-container(v-if="!existRoomType")
        .warning-message
          div 本施設、グループ施設に申込可能な部屋が設定されていないため、登録できません。
          div 設定をご確認ください。
        .mb-4

      div(v-if="template")
        .template-title 出力項目（入所申込）
        .description-message 出力したい項目を選択してください。
        .mb-2
        .template-container(v-if="template && existRoomType")
          .information.mb-2(v-if="template.information" style="white-space: pre-wrap; word-wrap: break-word;") {{ template.information }}
          .template(v-for="(property, index) in template.template.properties")
            WaiterTemplateSelectItem(v-model="template.template.properties[index]" :waiterViewableFacilitiesMap="waiterViewableFacilitiesMap" :isChaild="false")
        .mb-4
      
      div(v-if="judgementTemplate")
        .template-title 出力項目（入所判定）
        .description-message 出力したい項目を選択してください。
        .mb-2
        .template-container
          .template(v-for="(property, index) in judgementTemplate.template.properties")
            WaiterJudgeTemplateSelectItem(v-model="judgementTemplate.template.properties[index]" :isChaild="false")
        .mb-2
        b-form-checkbox#output-judgement-total-point(v-model="outputJudgementTotalPoint" name="output-judgement-total-point" :value="true" :unchecked-value="false") 合計点
        .mb-4

      .template-title その他項目
      .description-message 追加出力する項目を選択してください。
      .mb-2
      b-form-checkbox#output-application-date(v-model="outputApplicationDate" name="output-application-date" :value="true" :unchecked-value="false") 申込日
      b-form-checkbox#output-update-date(v-model="outputUpdateDate" name="output-update-date" :value="true" :unchecked-value="false") 最終更新日
      b-form-checkbox#output-step(v-model="outputStep" name="output-step" :value="true" :unchecked-value="false") ステップ
      .mb-4

      .filters-title フィルタリング
      .description-message 出力する待機者の絞り込み条件を選択してください。
      .mb-2
      .advanced-filters(style="border: 0;")
        .d-flex.flex-row.flex-wrap
          //- フィルタリング(ステップ)
          .advanced-filter.mr-2.align-self-start
            span.table-option-text.font-weight-bold ステップ:
            b-form-checkbox(v-model="filter.status.application") 入所申込み
            b-form-checkbox(v-model="filter.status.receivedApplication") 申込み受理
            b-form-checkbox(v-model="filter.status.completeApplication") 判定済
            b-form-checkbox(v-model="filter.status.confirmAdmission") 入所意向確認
            b-form-checkbox(v-model="filter.status.finalJudge") 最終判定中
            b-form-checkbox(v-model="filter.status.completeFinalJudge") 最終判定済
            b-form-checkbox(v-model="filter.status.admissionProcedure") 入所手続き
            b-form-checkbox(v-model="filter.status.canceled") 取り下げ
          //- 性別
          .advanced-filter.mr-2.align-self-start
            span.table-option-text.font-weight-bold 性別:
            b-form-checkbox(v-model="filter.gender.men") 男性
            b-form-checkbox(v-model="filter.gender.women") 女性
          //- 部屋種別
          .advanced-filter.mr-2.align-self-start
            span.table-option-text.font-weight-bold 部屋種別:
            b-form-checkbox(v-if="_facility.recruitmentRoom.multiBed" v-model="filter.roomType.multiBed") 従来型多床室
            b-form-checkbox(v-if="_facility.recruitmentRoom.conventinalSingle" v-model="filter.roomType.conventinalSingle") 従来型個室
            b-form-checkbox(v-if="_facility.recruitmentRoom.unitTypeSingle" v-model="filter.roomType.unitTypeSingle") ユニット型個室
            b-form-checkbox(v-if="_facility.recruitmentRoom.single" v-model="filter.roomType.single") 個室
            b-form-checkbox(v-if="_facility.recruitmentRoom.double" v-model="filter.roomType.double") ２人部屋（夫婦部屋）
            b-form-checkbox(v-for="(roomType, index) in filter.customRoomType" v-model="roomType.value" :key="roomType.id") {{ roomType.name }}
          //- 要介護度
          .advanced-filter.mr-2.align-self-start
            span.table-option-text.font-weight-bold 要介護度:
            b-form-checkbox(v-model="filter.careLevel.careLevel1000") 自立
            b-form-checkbox(v-model="filter.careLevel.careLevel1010") 申請中
            b-form-checkbox(v-model="filter.careLevel.careLevel2010") 要支援１
            b-form-checkbox(v-model="filter.careLevel.careLevel2020") 要支援２
            b-form-checkbox(v-model="filter.careLevel.careLevel3010") 要介護１
            b-form-checkbox(v-model="filter.careLevel.careLevel3020") 要介護２
            b-form-checkbox(v-model="filter.careLevel.careLevel3030") 要介護３
            b-form-checkbox(v-model="filter.careLevel.careLevel3040") 要介護４
            b-form-checkbox(v-model="filter.careLevel.careLevel3050") 要介護５
          //- ラベル
          .advanced-filter.mr-2.align-self-start
            span.table-option-text.font-weight-bold ラベル:
            .d-flex.flex-row
              .d-flex.flex-column
                .label(v-for="(label, index) in filter.labels.slice(0, 5)")
                  b-form-checkbox(v-if="label.use" v-model="label.checked" :class="{ 'mt-2': index != 0 }")
                    span.waiter-label(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}
              .d-flex.flex-column.ml-2(v-if="0 < filter.labels.slice(5).length")
                .label(v-for="(label, index) in filter.labels.slice(5)")
                  b-form-checkbox(v-if="label.use" v-model="label.checked" :class="{ 'mt-2': index != 0 }")
                    span.waiter-label(:style="{ 'color': label.color, 'background-color': label.bgColor }") {{ label.name }}

    .box-footer.with-border.register-footer
      .buttons
        button.btn.download-btn(v-if="existApplicationTemplateId" @click="onDonwnload" type="button") ダウンロード
        button.btn.cancel-btn(@click="gotoWaiterList" type="button") キャンセル
  
  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  ProgressLoading(v-model="currentOutputCsvLineCount" :max="csvLineCount" :isBusy="progressLoading" :message="progressMessage")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { userStore, itemListFilterStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";

import SystemError from "@/commons/models/SystemError";
import LoginUser from "@/store/LoginUser";

import FacilitiesService, { CustomRecruitmentRoom, FacilityGetModel } from "@/commons/services/Facilities";
import WaiterLabelsService, { WaiterLabelsGetModel } from "@/commons/services/WaiterLabels";
import TemplatesService, {
  AdmissionApplicationTemplatesGetModel,
  RoomType,
  TemplateItem,
  TemplateItemAddress,
  TemplateItemBirthday,
  TemplateItemCheckbox,
  TemplateItemGroup,
  TemplateItemInput,
  TemplateItemMultipleCheckbox,
  TemplateItemName,
  TemplateItemRadio,
  TemplateItemRadioGroup,
  TemplateItemRoomType,
  TemplateItemSection,
  TemplateItemSelect,
  TemplateItemSwitchCheckbox,
  TemplateItemTel,
  TemplateItemText,
  TemplateItemTextarea,
  TemplateItemYearMonth,
  TemplateItemYearMonthDate,
  TemplateType
} from "@/commons/services/AdmissionApplicationTemplates";
import JudgementTemplatesService, {
  AdmissionJudgementTemplatesGetModel,
  TemplateItemText as JudgeTemplateItemText,
  TemplateItemRadio as JudgeTemplateItemRadio,
  TemplateItemMultipleCheckbox as JudgeTemplateItemMultipleCheckbox,
  TemplateItemRadioGroup as JudgeTemplateItemRadioGroup,
  CalcType
} from "@/commons/services/AdmissionJudgementTemplates";
import WaitersService, { AdmissionJudgement, WaitersGetModel } from "@/commons/services/Waiters";
import { ResidentStatus } from "@/commons/services/Residents";

import PageLoading from "@/pc/basics/PageLoading.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";
import WaiterTemplateSelectItem, { SelectTemplateItem } from "@/pc/containers/waiters/WaiterTemplateSelectItem.vue";
import WaiterJudgeTemplateSelectItem from "@/pc/containers/waiters/WaiterJudgeTemplateSelectItem.vue";

/** ナビゲーションガードのフックを使えるようにする */
Component.registerHooks(["beforeRouteLeave"]);

/**
 * ### 待機者登録画面コンポーネント
 */
@Component({
  components: {
    PageLoading,
    ProgressLoading,
    WaiterTemplateSelectItem,
    WaiterJudgeTemplateSelectItem
  }
})
export default class WaiterListDownload extends Vue {
  /** 施設サービス */
  @Inject("FacilitiesService") facilitiesService!: FacilitiesService;
  /** 待機者ラベルサービス */
  @Inject("WaiterLabelsService") waiterLabelsService!: WaiterLabelsService;
  /** 入所申込テンプレートサービス */
  @Inject("AdmissionApplicationTemplatesService") templatesService!: TemplatesService;
  /** 入所判定テンプレートサービス */
  @Inject("AdmissionJudgementTemplatesService") judgementTemplatesService!: JudgementTemplatesService;
  /** 待機者サービス */
  @Inject("WaitersService") waitersService!: WaitersService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";

  /** 現在の出力済みCSV行数 */
  currentOutputCsvLineCount: number = 0;
  /** CSV行数(母数) */
  csvLineCount: number = 0;
  /** プログレスローディングのメッセージ */
  progressMessage: string = "";
  /** プログレスローディングの表示可否 */
  progressLoading: boolean = false;

  /** 入所申込テンプレート情報が設定されているか否か */
  existApplicationTemplateId: boolean = true;
  /** 入所申込テンプレート */
  template: AdmissionApplicationTemplatesGetModel | null = null;
  /** 閲覧可能施設のMAP、key：施設ID、value：施設情報 */
  waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = new Map<number, FacilityGetModel>();

  /** 入所判定テンプレート */
  judgementTemplate: AdmissionJudgementTemplatesGetModel | null = null;

  /** 部屋種類が存在するか否か */
  existRoomType: boolean = true;

  /** 評価判定合計点 */
  outputJudgementTotalPoint: boolean = false;
  /** 申込日 */
  outputApplicationDate: boolean = false;
  /** 最終更新日 */
  outputUpdateDate: boolean = false;
  /** ステップ */
  outputStep: boolean = false;

  /** フィルタリング条件 */
  filter: FilterSetting = {
    searchWord: "",
    status: {
      application: false,
      receivedApplication: false,
      completeApplication: false,
      confirmAdmission: false,
      finalJudge: false,
      completeFinalJudge: false,
      admissionProcedure: false,
      canceled: false
    },
    gender: { men: false, women: false },
    roomType: {
      multiBed: false,
      conventinalSingle: false,
      unitTypeSingle: false,
      single: false,
      double: false
    },
    customRoomType: [],
    careLevel: {
      careLevel1000: false,
      careLevel1010: false,
      careLevel2010: false,
      careLevel2020: false,
      careLevel3010: false,
      careLevel3020: false,
      careLevel3030: false,
      careLevel3040: false,
      careLevel3050: false
    },
    labels: []
  };

  /** CSV出力時の部屋種類の列数。保持しないと空を格納する場合、値の受け渡しに困る */
  roomTypeRowCount: number = 0;

  get _facility(): FacilityGetModel {
    return userStore.getFacility;
  }

  /**
   * ### vue lifecycle mounted
   *
   * - タブ位置を復元し、初期化する
   * - モーダルで表示する他施設の待機者情報列を作成する
   */
  public async mounted(): Promise<void> {
    if (userStore.facility.useAdmissionApplicationTemplateId == null) {
      this.existApplicationTemplateId = false;
      return;
    }
    // フィルタの復元
    this.restoreFilterSetting();

    await this.createView();

    return;
  }

  /** フィルタ情報がstoreに存在する場合は復元する */
  private restoreFilterSetting(): void {
    if (this.$options.name && itemListFilterStore.filterMap[this.$options.name] != undefined) {
      this.filter = itemListFilterStore.filterMap[this.$options.name];
    }
    return;
  }

  /**
   * ### 画面情報作成
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    // 閲覧可能施設を取得しMAP化する
    const waiterViewableFacilities: Array<FacilityGetModel> = await this.getWaiterViewableFacilities(userStore);
    const waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = this.createWaiterViewableFacilitiesMap(waiterViewableFacilities);
    this.waiterViewableFacilitiesMap = waiterViewableFacilitiesMap;

    // フィルター情報を作成する
    const labels: Array<WaiterLabelsGetModel> = await this.getWaiterLabels();
    const filterLabels: Array<FilterLabel> = this.createFilterLabels(labels);
    this.filter.labels = filterLabels;

    const customRoomType: Array<FilterCustomRoomType> = this.createFilterCustomRoomType();
    this.filter.customRoomType = customRoomType;

    // 部屋種類が設定されているか
    this.existRoomType = this.getExistRoomType(userStore.facility, waiterViewableFacilities);

    // テンプレートを取得して初期化する
    // テンプレートを使用しない仕様が追加されたのでチェックする
    if (userStore.facility.useAdmissionApplicationTemplateId) {
      const template: AdmissionApplicationTemplatesGetModel = await this.getTemplate();
      this.initializeTemplate(template.template.properties, waiterViewableFacilities);
      this.template = template;
    }
    // テンプレートを使用しない仕様が追加されたのでチェックする
    if (userStore.facility.useAdmissionJudgementTemplateId) {
      const judgementTemplate: AdmissionJudgementTemplatesGetModel = await this.getJudgementTemplate();
      this.initializeTemplate(judgementTemplate.template.properties, waiterViewableFacilities);
      this.judgementTemplate = judgementTemplate;
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 閲覧可能施設情報を取得する
   */
  public async getWaiterViewableFacilities(userStore: LoginUser): Promise<Array<FacilityGetModel>> {
    const waiterViewableFacilities: Array<FacilityGetModel> = [];
    for (const facilityId of userStore.facility.waiterViewableFacilities) {
      const response: FacilityGetModel = await this.facilitiesService.get(userStore, { targetFacilityId: facilityId });
      waiterViewableFacilities.push(response);
    }
    return waiterViewableFacilities;
  }

  /**
   * ### 閲覧可能施設情報のMAPを作成する
   */
  public createWaiterViewableFacilitiesMap(waiterViewableFacilities: Array<FacilityGetModel>): Map<number, FacilityGetModel> {
    let waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = new Map<number, FacilityGetModel>();

    waiterViewableFacilitiesMap.set(userStore.facility.id, userStore.facility);

    for (const facility of waiterViewableFacilities) {
      waiterViewableFacilitiesMap.set(facility.id, facility);
    }

    return waiterViewableFacilitiesMap;
  }

  /**
   * ### 待機者ラベルを取得する
   */
  public async getWaiterLabels(): Promise<Array<WaiterLabelsGetModel>> {
    const response: Array<WaiterLabelsGetModel> = await this.waiterLabelsService.gets(userStore);
    return response;
  }

  /**
   * ### 待機者ラベルフィルタリング選択肢を作成する
   */
  public createFilterLabels(labels: Array<WaiterLabelsGetModel>): Array<FilterLabel> {
    let filterLabels: Array<FilterLabel> = [];
    for (const label of labels) {
      filterLabels.push({
        ...label,
        checked: false
      });
    }
    return filterLabels;
  }

  /**
   * ### 部屋種類フィルタリング選択肢を作成する
   */
  public createFilterCustomRoomType(): Array<FilterCustomRoomType> {
    let filterCustomRoomType: Array<FilterCustomRoomType> = [];
    if (userStore.facility.customRecruitmentRoom) {
      for (const room of userStore.facility.customRecruitmentRoom) {
        if (room.use == true) {
          filterCustomRoomType.push({
            id: room.id,
            name: room.name,
            value: false
          });
        }
      }
    }
    return filterCustomRoomType;
  }

  /**
   * ### 部屋種類が存在するかを返す
   */
  public getExistRoomType(mineFacility: FacilityGetModel, waiterViewableFacilities: Array<FacilityGetModel>): boolean {
    const mineFacilityExistRoomType: boolean = this.isRecruitmentRoom(mineFacility) || this.isCustomRequiredRecruitmentRoom(mineFacility);

    let waiterViewableFacilitiesEmptyRoomType: boolean = false;
    for (const viewableFacility of waiterViewableFacilities) {
      const existRoomType: boolean = this.isRecruitmentRoom(viewableFacility) || this.isCustomRequiredRecruitmentRoom(viewableFacility);
      waiterViewableFacilitiesEmptyRoomType = waiterViewableFacilitiesEmptyRoomType || existRoomType;
    }

    return mineFacilityExistRoomType || waiterViewableFacilitiesEmptyRoomType;
  }

  public isRecruitmentRoom(facility: FacilityGetModel): boolean {
    if (
      (facility.recruitmentRoom.multiBed ||
        facility.recruitmentRoom.conventinalSingle ||
        facility.recruitmentRoom.unitTypeSingle ||
        facility.recruitmentRoom.double ||
        facility.recruitmentRoom.single) == true
    ) {
      return true;
    } else {
      return false;
    }
  }

  public isCustomRequiredRecruitmentRoom(facility: FacilityGetModel): boolean {
    if (!facility.customRecruitmentRoom) {
      return false;
    }
    for (const room of facility.customRecruitmentRoom) {
      if (room.use == true) {
        return true;
      }
    }
    return false;
  }

  /**
   * ### テンプレート情報を取得する
   */
  public async getTemplate(): Promise<AdmissionApplicationTemplatesGetModel> {
    const response: AdmissionApplicationTemplatesGetModel = await this.templatesService.get(userStore);
    return response;
  }

  /**
   * ### テンプレートの初期化
   *
   * - 選択しているか否かを初期化する
   * - ここで初期化しないとvueが値変更を監視できない
   * - 部屋種類はDBのレコード情報と施設の設定情報を使用して初期値を作成する
   */
  public initializeTemplate(properties: Array<TemplateItem>, waiterViewableFacilities: Array<FacilityGetModel>): void {
    for (const property of properties) {
      if (this.hasProperties(property) == true) {
        if (property.type == TemplateType.SECTION) {
          const item: TemplateItemSection = property as TemplateItemSection;

          if (item.properties && Array.isArray(item.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            this.initializeTemplate(item.properties, waiterViewableFacilities);
          }
        } else if (property.type == TemplateType.GROUP) {
          const item: TemplateItemGroup = property as TemplateItemGroup;

          if (item.properties && Array.isArray(item.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            for (const childProperties of item.properties) {
              if (childProperties && Array.isArray(childProperties)) {
                this.initializeTemplate(childProperties, waiterViewableFacilities);
              }
            }
          }
        } else if (property.type == TemplateType.RADIO_GROUP) {
          const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

          if (item.properties && Array.isArray(item.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            for (const childProperties of item.properties) {
              if (childProperties && Array.isArray(childProperties.properties)) {
                this.initializeTemplate(childProperties.properties, waiterViewableFacilities);
              }
            }
          }
        } else if (property.type == TemplateType.SWITCH_CHECKBOX) {
          const item: TemplateItemSwitchCheckbox = property as TemplateItemSwitchCheckbox;

          // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
          if (item.properties && Array.isArray(item.properties)) {
            this.initializeTemplate(item.properties, waiterViewableFacilities);
          }
        }
      }

      const inputItem: SelectTemplateItem = property as SelectTemplateItem;
      inputItem.checked = false;

      // 部屋種類の場合は選択項目を作る必要があるのでanswerを作成する必要がある
      if (inputItem.type == TemplateType.ROOM_TYPE) {
        let roomTypeItem: TemplateItemRoomType = property as TemplateItemRoomType;
        roomTypeItem.answer = this.createRoomTypeCheckbox(roomTypeItem, waiterViewableFacilities);
      }
    }

    return;
  }

  public hasProperties(item: TemplateItem): boolean {
    switch (item.type) {
      case TemplateType.SECTION:
      case TemplateType.GROUP:
      case TemplateType.RADIO_GROUP:
      case TemplateType.SWITCH_CHECKBOX: {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  /**
   * ### 入居判定テンプレートを取得する
   */
  public async getJudgementTemplate(): Promise<AdmissionJudgementTemplatesGetModel> {
    const response: AdmissionJudgementTemplatesGetModel = await this.judgementTemplatesService.get(userStore);
    return response;
  }

  /**
   * ### 部屋種類の初期値を作成する
   *
   * - 部屋種類(固有)の作成を行う
   *   - 自施設、閲覧可能施設の両方を設定対象とする
   * - 施設に部屋種類(固有)が存在する場合、部屋種類(固有)を作り直して設定する
   *   - 既存入力されている部屋種類(固有)をMAP化する
   *   - 施設の部屋種類(固有)の設定情報をもとに、MAPから前回入力値を復元する
   * - 施設に部屋種類(固有)が存在しない場合、部屋種類(固有)は空配列を設定する
   *
   * - 部屋種類(共通)の作成を行う
   *   - 自施設、閲覧可能施設の両方を設定対象とする
   * - 施設の部屋種類の情報をコピーする
   */
  public createRoomTypeCheckbox(item: TemplateItemRoomType, waiterViewableFacilities: Array<FacilityGetModel>): Array<RoomType> {
    let answer: Array<RoomType> = [];

    let customRecruitmentRoom: Array<CustomRecruitmentRoom> = [];
    if (userStore.facility.customRecruitmentRoom) {
      for (const room of userStore.facility.customRecruitmentRoom) {
        customRecruitmentRoom.push({
          id: room.id,
          name: room.name,
          abbreviationName: room.abbreviationName,
          color: room.color,
          use: false
        });
      }
    }

    const mineFacilityRoomTypeCheckbox: RoomType = {
      facilityId: userStore.facility.id,
      recruitmentRoom: {
        multiBed: false,
        conventinalSingle: false,
        unitTypeSingle: false,
        double: false,
        single: false
      },
      customRecruitmentRoom: customRecruitmentRoom
    };
    answer.push(mineFacilityRoomTypeCheckbox);

    for (const viewableFacility of waiterViewableFacilities) {
      // 部屋設定が全てfalseの場合は画面に表示する必要が無いのでスキップ
      if (!this.isRecruitmentRoom(viewableFacility) && !this.isCustomRequiredRecruitmentRoom(viewableFacility)) {
        continue;
      }

      let customRecruitmentRoom: Array<CustomRecruitmentRoom> = [];
      if (viewableFacility.customRecruitmentRoom) {
        for (const room of viewableFacility.customRecruitmentRoom) {
          customRecruitmentRoom.push({
            id: room.id,
            name: room.name,
            abbreviationName: room.abbreviationName,
            color: room.color,
            use: false
          });
        }
      }

      const roomTypeCheckbox: RoomType = {
        facilityId: viewableFacility.id,
        recruitmentRoom: {
          multiBed: false,
          conventinalSingle: false,
          unitTypeSingle: false,
          double: false,
          single: false
        },
        customRecruitmentRoom: customRecruitmentRoom
      };
      answer.push(roomTypeCheckbox);
    }

    item.answer = answer;

    return item.answer;
  }

  /**
   * ### ダウンロードボタン押下イベント
   *
   * - 待機者を取得する
   *   - 待機者を設定されたフィルタリング設定でフィルタリングする
   * - 出力対象の項目をリストアップする
   * - 待機者の各情報を検索してCSV出力する
   */
  public async onDonwnload(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "待機者情報取得中...";

    const waiters: Array<WaitersGetModel> = await this.getWaiters();
    const filterdWaiters: Array<WaitersGetModel> = await this.filteringWaiters(waiters);

    const targets: Array<{ id: string; label: string; type: string; item: TemplateItem }> = [];
    if (this.template) {
      const template: AdmissionApplicationTemplatesGetModel = this.template;
      this.pickupDownloadTargets(targets, template.template.properties);
    }

    const judgementTargets: Array<{ id: string; label: string; type: string; item: TemplateItem }> = [];
    if (this.judgementTemplate) {
      const judgementTemplate: AdmissionJudgementTemplatesGetModel = this.judgementTemplate;
      this.pickupDownloadTargets(judgementTargets, judgementTemplate.template.properties);
    }

    this.isBusy = false;

    this.currentOutputCsvLineCount = 0;
    this.csvLineCount = filterdWaiters.length;
    this.progressMessage = "待機者情報出力中。\n完了するまでそのままお待ちください。\n出力中に別画面に遷移しますと処理がキャンセルされます。";
    this.progressLoading = true;

    const csvTitle: string = this.createCsvTitle(targets, judgementTargets);
    const csvData: string = this.createCsvLines(filterdWaiters, targets, judgementTargets); // この中で出力情報作成と進捗更新する
    const fileName: string = `HitomeQコネクト-待機者リスト-${this.$dateUtil.convertDateToString(new Date(), "yyyymmdd")}.csv`;

    this.downloadCsv(csvTitle + csvData, fileName);

    this.progressLoading = false;

    return;
  }

  /**
   * ### 待機者を取得する
   *
   * - 取得制限をしないためstartIndex、endIndexを指定しない
   */
  public async getWaiters(): Promise<Array<WaitersGetModel>> {
    let response: Array<WaitersGetModel> = [];

    try {
      response = await this.waitersService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.waitersService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.waitersService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 待機者をフィルタリングする
   *
   * - フィルタリング設定は画面入力されているものを使用する
   */
  public filteringWaiters(waiters: Array<WaitersGetModel>) {
    return waiters.filter((waiter: WaitersGetModel) => {
      return (
        this.filterStatus(waiter, this.filter) &&
        this.filterGender(waiter, this.filter) &&
        this.filterRoomType(waiter, this.filter) &&
        this.filterCareLevel(waiter, this.filter) &&
        this.filterLabel(waiter, this.filter)
      );
    });
  }

  /**
   * ### 利用者状態によるフィルタリング
   *
   * - 「全て」を選択した場合はフィルタリング対象外
   */
  public filterStatus(waiter: WaitersGetModel, filter: FilterSetting): boolean {
    if (
      filter.status.application == false &&
      filter.status.receivedApplication == false &&
      filter.status.completeApplication == false &&
      filter.status.confirmAdmission == false &&
      filter.status.finalJudge == false &&
      filter.status.completeFinalJudge == false &&
      filter.status.admissionProcedure == false &&
      filter.status.canceled == false
    ) {
      return true;
    }

    if (filter.status.application == true) {
      if (waiter.status == ResidentStatus.APPLICATION) {
        return true;
      }
    }
    if (filter.status.receivedApplication == true) {
      if (waiter.status == ResidentStatus.RECEIVED_APPLICATION) {
        return true;
      }
    }
    if (filter.status.completeApplication == true) {
      if (waiter.status == ResidentStatus.COMPLETE_APPLICATION) {
        return true;
      }
    }
    if (filter.status.confirmAdmission == true) {
      if (waiter.status == ResidentStatus.CONFIRM_ADMISSION) {
        return true;
      }
    }
    if (filter.status.finalJudge == true) {
      if (waiter.status == ResidentStatus.FINAL_JUDGE) {
        return true;
      }
    }
    if (filter.status.completeFinalJudge == true) {
      if (waiter.status == ResidentStatus.COMPLETE_FINAL_JUDGE) {
        return true;
      }
    }
    if (filter.status.admissionProcedure == true) {
      if (waiter.status == ResidentStatus.ADMISSION_PROCEDURE) {
        return true;
      }
    }
    if (filter.status.canceled == true) {
      if (waiter.status == ResidentStatus.CANCELED) {
        return true;
      }
    }

    return false;
  }

  /**
   * ### 性別によるフィルタリング
   *
   * - 男性、女性が選択されていない場合はフィルタリング対象外
   */
  public filterGender(waiter: WaitersGetModel, filter: FilterSetting): boolean {
    if (filter.gender.men == false && filter.gender.women == false) {
      return true;
    }

    if (filter.gender.men == true) {
      if (waiter.gender == "男性") {
        return true;
      }
    }
    if (filter.gender.women == true) {
      if (waiter.gender == "女性") {
        return true;
      }
    }

    return false;
  }

  /**
   * ### 部屋種類によるフィルタリング
   *
   * - 部屋種類(施設固有も含む)が選択されていない場合はフィルタリング対象外
   * - 待機者の部屋種類が存在しない場合はフィルタリング対象外
   */
  public filterRoomType(waiter: WaitersGetModel, filter: FilterSetting): boolean {
    let customRoomTypeChecked: boolean = false;
    for (const roomType of filter.customRoomType) {
      if (roomType.value == true) {
        customRoomTypeChecked = true;
        break;
      }
    }
    if (
      filter.roomType.multiBed == false &&
      filter.roomType.conventinalSingle == false &&
      filter.roomType.unitTypeSingle == false &&
      filter.roomType.single == false &&
      filter.roomType.double == false &&
      customRoomTypeChecked == false
    ) {
      return true;
    }

    if (!waiter.waiter || !waiter.waiter.admissionApplication || !waiter.waiter.admissionApplication.templateAnswer) {
      return false;
    }

    const item: TemplateItemRoomType | null = this.serachTemplateProperty(waiter.waiter.admissionApplication.templateAnswer.properties, "roomType") as TemplateItemRoomType;
    if (item == null) {
      return true;
    }

    for (const answer of item.answer) {
      if (userStore.facility.id == answer.facilityId) {
        // 施設共通の部屋種類
        if (filter.roomType.multiBed == true) {
          if (answer.recruitmentRoom.multiBed == true) {
            return true;
          }
        }
        if (filter.roomType.conventinalSingle == true) {
          if (answer.recruitmentRoom.conventinalSingle == true) {
            return true;
          }
        }
        if (filter.roomType.unitTypeSingle == true) {
          if (answer.recruitmentRoom.unitTypeSingle == true) {
            return true;
          }
        }
        if (filter.roomType.single == true) {
          if (answer.recruitmentRoom.single == true) {
            return true;
          }
        }
        if (filter.roomType.double == true) {
          if (answer.recruitmentRoom.double == true) {
            return true;
          }
        }

        // 施設固有の部屋種類
        for (const customRoomType of filter.customRoomType) {
          if (customRoomType.value == true) {
            // 既存待機者等、customRecruitmentRoomが存在しない場合はスキップする
            if (!answer.customRecruitmentRoom) {
              continue;
            }
            for (const customRoom of answer.customRecruitmentRoom) {
              if (customRoomType.id == customRoom.id && customRoom.use == true) {
                return true;
              }
            }
          }
        }
      }
    }

    return false;
  }

  /**
   * ### テンプレートのpropertiesから指定されたidの要素を返す
   */
  public serachTemplateProperty(properties: Array<TemplateItem>, idName: string): TemplateItemInput | null {
    for (const property of properties) {
      // 配下にperopetiesがあれば再帰検索
      if (this.hasProperties(property) == true) {
        if (property.type == TemplateType.SECTION) {
          const section: TemplateItemSection = property as TemplateItemSection;
          const item: TemplateItemInput | null = this.serachTemplateProperty(section.properties, idName);
          if (item != null) {
            return item;
          }
        } else if (property.type == TemplateType.GROUP) {
          const group: TemplateItemGroup = property as TemplateItemGroup;
          if (group.properties != null) {
            for (const childProperties of group.properties) {
              const item: TemplateItemInput | null = this.serachTemplateProperty(childProperties, idName);
              if (item != null) {
                return item;
              }
            }
          } else {
            return null;
          }
        } else if (property.type == TemplateType.RADIO_GROUP) {
          const radioGroup: TemplateItemRadioGroup = property as TemplateItemRadioGroup;
          if (radioGroup.properties != null) {
            for (const childProperties of radioGroup.properties) {
              if (childProperties.properties != null) {
                const item: TemplateItemInput | null = this.serachTemplateProperty(childProperties.properties, idName);
                if (item != null) {
                  return item;
                }
              }
            }
          } else {
            return null;
          }
        } else if (property.type == TemplateType.SWITCH_CHECKBOX) {
          const switchCheckbox: TemplateItemSwitchCheckbox = property as TemplateItemSwitchCheckbox;
          if (switchCheckbox.properties != null) {
            const item: TemplateItemInput | null = this.serachTemplateProperty(switchCheckbox.properties, idName);
            if (item != null) {
              return item;
            }
          } else {
            return null;
          }
        }
      }

      if (property.id == idName) {
        return property as TemplateItemInput;
      }
    }
    return null;
  }

  /**
   * ### 要介護度によるフィルタリング
   *
   * - 要介護度が選択されていない場合はフィルタリング対象外
   * - 待機者の要介護度が存在しない場合はフィルタリング対象外
   */
  public filterCareLevel(waiter: WaitersGetModel, filter: FilterSetting): boolean {
    if (
      filter.careLevel.careLevel1000 == false &&
      filter.careLevel.careLevel1010 == false &&
      filter.careLevel.careLevel2010 == false &&
      filter.careLevel.careLevel2020 == false &&
      filter.careLevel.careLevel3010 == false &&
      filter.careLevel.careLevel3020 == false &&
      filter.careLevel.careLevel3030 == false &&
      filter.careLevel.careLevel3040 == false &&
      filter.careLevel.careLevel3050 == false
    ) {
      return true;
    }

    if (!waiter.waiter || !waiter.waiter.admissionApplication || !waiter.waiter.admissionApplication.templateAnswer) {
      return false;
    }

    const item: TemplateItemRadio | null = this.serachTemplateProperty(waiter.waiter.admissionApplication.templateAnswer.properties, "careLevel") as TemplateItemRadio;
    if (item == null) {
      return true;
    }

    if (filter.careLevel.careLevel1000 == true) {
      if (item.answer == "1000") {
        return true;
      }
    }
    if (filter.careLevel.careLevel1010 == true) {
      if (item.answer == "1010") {
        return true;
      }
    }
    if (filter.careLevel.careLevel2010 == true) {
      if (item.answer == "2010") {
        return true;
      }
    }
    if (filter.careLevel.careLevel2020 == true) {
      if (item.answer == "2020") {
        return true;
      }
    }
    if (filter.careLevel.careLevel3010 == true) {
      if (item.answer == "3010") {
        return true;
      }
    }
    if (filter.careLevel.careLevel3020 == true) {
      if (item.answer == "3020") {
        return true;
      }
    }
    if (filter.careLevel.careLevel3030 == true) {
      if (item.answer == "3030") {
        return true;
      }
    }
    if (filter.careLevel.careLevel3040 == true) {
      if (item.answer == "3040") {
        return true;
      }
    }
    if (filter.careLevel.careLevel3050 == true) {
      if (item.answer == "3050") {
        return true;
      }
    }

    return false;
  }

  /**
   * ### ラベルによるフィルタリング
   *
   * - 全てが選択されていない場合はフィルタリング対象外
   */
  public filterLabel(waiter: WaitersGetModel, filter: FilterSetting): boolean {
    let waiterlabelMap: Map<number, number> = new Map<number, number>();
    if (waiter.waiter.labels) {
      for (const label of waiter.waiter.labels) {
        waiterlabelMap.set(label, label);
      }
    }

    let existChecked: boolean = false;
    for (const label of filter.labels) {
      if (label.checked == true) {
        existChecked = true;

        if (waiterlabelMap.get(label.id)) {
          return true;
        }
      }
    }
    if (existChecked == false) {
      return true;
    }

    return false;
  }

  /**
   * ### 画面で選択された項目のidを配列で返す
   *
   * - 再帰呼び出しするのでid配列は参照渡ししている
   */
  public pickupDownloadTargets(targets: Array<{ id: string; label: string; type: string; item: TemplateItem }>, properties: Array<TemplateItem>): void {
    for (const property of properties) {
      if (this.hasProperties(property) == true) {
        if (property.type == TemplateType.SECTION) {
          const item: TemplateItemSection = property as TemplateItemSection;

          if (item.properties && Array.isArray(item.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            this.pickupDownloadTargets(targets, item.properties);
          }
        } else if (property.type == TemplateType.GROUP) {
          const item: TemplateItemGroup = property as TemplateItemGroup;

          if (item.properties && Array.isArray(item.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            for (const childProperties of item.properties) {
              if (childProperties && Array.isArray(childProperties)) {
                this.pickupDownloadTargets(targets, childProperties);
              }
            }
          }
        } else if (property.type == TemplateType.RADIO_GROUP) {
          const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

          if (item.properties && Array.isArray(item.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            for (const childProperties of item.properties) {
              if (childProperties && Array.isArray(childProperties.properties)) {
                this.pickupDownloadTargets(targets, childProperties.properties);
              }
            }
          }
        } else if (property.type == TemplateType.SWITCH_CHECKBOX) {
          const item: TemplateItemSwitchCheckbox = property as TemplateItemSwitchCheckbox;

          // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
          if (item.properties && Array.isArray(item.properties)) {
            this.pickupDownloadTargets(targets, item.properties);
          }
        }
      }

      const inputItem: SelectTemplateItem = property as SelectTemplateItem;
      if (inputItem.checked == true) {
        targets.push({
          id: inputItem.id,
          label: inputItem.label,
          type: inputItem.type,
          item: inputItem
        });
      }
    }

    return;
  }

  /**
   * ### CSVの1行目(列名)を作成する
   *
   * - BOM付きで出力させるために`\ufeff`を先頭に付与
   * - 出力対象のlabelをカンマ区切りして列名として使用する
   * - 末尾に改行コードを付与する
   */
  public createCsvTitle(
    targets: Array<{ id: string; label: string; type: string; item: TemplateItem }>,
    judgementTargets: Array<{ id: string; label: string; type: string; item: TemplateItem }>
  ): string {
    let labels: string[] = [];

    // 選択された項目の追加(入所申込)
    for (const target of targets) {
      switch (target.type) {
        case TemplateType.ADDRESS: {
          labels.push(`${target.label}（郵便番号）,${target.label}（住所）`);
          break;
        }
        case TemplateType.ROOM_TYPE: {
          labels.push(this.createRoomTypeCsvTitle(target.item as TemplateItemRoomType));
          break;
        }
        case TemplateType.NAME: {
          labels.push(`${target.label}（姓）,${target.label}（名）,${target.label}（せい）,${target.label}（めい）`);
          break;
        }
        default: {
          labels.push(target.label);
          break;
        }
      }
    }

    // 選択された項目の追加(入所判定)
    for (const target of judgementTargets) {
      labels.push(target.label);
    }
    if (this.outputJudgementTotalPoint == true) {
      labels.push("評価判定合計点");
    }

    // その他項目
    if (this.outputApplicationDate == true) {
      labels.push("申込日");
    }
    if (this.outputUpdateDate == true) {
      labels.push("最終更新日");
    }
    if (this.outputStep == true) {
      labels.push("ステップ");
    }

    return "\ufeff" + labels.join(",") + "\n";
  }

  /**
   * ### 部屋種類のCSV列名を作成する
   *
   * - 部屋種類の中で選択されているものでラベルを作成する
   * - ラベルは,区切りの文字列で返す
   */
  public createRoomTypeCsvTitle(item: TemplateItemRoomType): string {
    let labels: string[] = [];

    const roomTypes: Array<RoomType> = item.answer as Array<RoomType>;
    for (const roomType of roomTypes) {
      const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);
      if (facility) {
        // 部屋種類ラベル
        if (facility.recruitmentRoom.multiBed == true) {
          labels.push(`${facility.name}：従来型多床室`);
        }
        if (facility.recruitmentRoom.conventinalSingle) {
          labels.push(`${facility.name}：従来型個室`);
        }
        if (facility.recruitmentRoom.unitTypeSingle) {
          labels.push(`${facility.name}：ユニット型個室`);
        }
        if (facility.recruitmentRoom.single) {
          labels.push(`${facility.name}：個室`);
        }
        if (facility.recruitmentRoom.double) {
          labels.push(`${facility.name}：２人部屋（夫婦部屋）`);
        }

        // カスタム部屋種類ラベル
        if (facility.customRecruitmentRoom) {
          const customRecruitmentRoomMapById: Map<string, CustomRecruitmentRoom> = new Map<string, CustomRecruitmentRoom>();
          for (const room of facility.customRecruitmentRoom) {
            if (room.use == true) {
              customRecruitmentRoomMapById.set(room.id, room);
            }
          }
          if (roomType.customRecruitmentRoom) {
            for (const customRecruitmentRoom of roomType.customRecruitmentRoom) {
              const room: CustomRecruitmentRoom | undefined = customRecruitmentRoomMapById.get(customRecruitmentRoom.id);
              if (room) {
                labels.push(`${facility.name}：${room.name}`);
              }
            }
          }
        }
      }
    }

    // ここで列数を保持することで後続処理で部屋種類の列数の整合性を管理する
    this.roomTypeRowCount = labels.length;

    return labels.join(",");
  }

  /**
   * ### CSV出力する行情報を作成する
   *
   * - 待機者1人で1行の情報とする
   *   - 行情報の末尾は\nで区切る
   * - 項目毎のanswer値を出力する
   *   - CSV出力するのでanswer値をカンマ区切りで出力する
   */
  public createCsvLines(
    waiters: Array<WaitersGetModel>,
    targets: Array<{ id: string; label: string; item: TemplateItem }>,
    judgementTargets: Array<{ id: string; label: string; type: string }>
  ): string {
    let csvLines: string[] = []; // 全行情報
    for (let i = 0; i < waiters.length; i++) {
      let csvLine: string[] = []; // 行情報

      // 選択項目の追加(入所申込)
      const applicationItemMapById: Map<string, TemplateItem> = new Map<string, TemplateItem>();
      if (waiters[i].waiter && waiters[i].waiter.admissionApplication && waiters[i].waiter.admissionApplication.templateAnswer) {
        this.createItemMapById(waiters[i].waiter.admissionApplication.templateAnswer.properties, applicationItemMapById);
      }
      for (const target of targets) {
        const item: TemplateItem | undefined = applicationItemMapById.get(target.id);
        if (item) {
          csvLine.push(this.getItemValue(item, target.item));
        } else {
          csvLine.push(this.createEmptyItemValue(target.item));
        }
      }

      // 選択項目の追加(入所判定)
      const judgementItemMapById: Map<string, TemplateItem> = new Map<string, TemplateItem>();
      if (waiters[i].waiter.admissionJudgement && waiters[i].waiter.admissionJudgement.templateAnswer) {
        this.createItemMapById(waiters[i].waiter.admissionJudgement.templateAnswer.properties, judgementItemMapById);
      }
      for (const target of judgementTargets) {
        if (waiters[i].waiter.admissionJudgement && waiters[i].waiter.admissionJudgement.templateAnswer) {
          const item: TemplateItem | undefined = judgementItemMapById.get(target.id);
          if (item) {
            csvLine.push(this.getItemPoint(item));
          } else {
            csvLine.push("");
          }
        } else {
          csvLine.push("");
        }
      }
      if (waiters[i].waiter.admissionJudgement && waiters[i].waiter.admissionJudgement.templateAnswer) {
        if (this.outputJudgementTotalPoint == true) {
          csvLine.push(this.calculateJudgementPopint(waiters[i].waiter.admissionJudgement));
        }
      } else {
        csvLine.push("");
      }

      // その他項目
      if (this.outputApplicationDate == true) {
        if (waiters[i].waiter && waiters[i].waiter.admissionApplication) {
          csvLine.push(this.$dateUtil.convertNumberToString(waiters[i].waiter.admissionApplication.created, "yyyy年mm月dd日"));
        } else {
          csvLine.push("");
        }
      }
      if (this.outputUpdateDate == true) {
        csvLine.push(this.$dateUtil.convertNumberToString(waiters[i].updated, "yyyy年mm月dd日"));
      }
      if (this.outputStep == true) {
        csvLine.push(this.convertStatusName(waiters[i].status));
      }

      csvLines.push(csvLine.join(","));

      this.currentOutputCsvLineCount = i + 1; // 進捗を更新
    }
    return csvLines.join("\n");
  }

  /**
   * ### 待機者レコードで保持しているテンプレート情報(回答含む)のMAPを作成する
   *
   * - key：要素ID、value：answer値
   */
  public createItemMapById(properties: Array<TemplateItem>, itemMapById: Map<string, TemplateItem>): void {
    for (const property of properties) {
      // 配下にperopetiesがあれば再帰検索
      if (this.hasProperties(property) == true) {
        if (property.type == TemplateType.SECTION) {
          const section: TemplateItemSection = property as TemplateItemSection;
          if (section.properties && Array.isArray(section.properties)) {
            this.createItemMapById(section.properties, itemMapById);
          }
        } else if (property.type == TemplateType.GROUP) {
          const group: TemplateItemGroup = property as TemplateItemGroup;
          if (group.properties && Array.isArray(group.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            for (const childProperties of group.properties) {
              if (childProperties && Array.isArray(childProperties)) {
                this.createItemMapById(childProperties, itemMapById);
              }
            }
          }
        } else if (property.type == TemplateType.RADIO_GROUP) {
          const radioGroup: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

          // 項目として出力するので、値も別途保持する
          itemMapById.set(property.id, property);

          if (radioGroup.properties && Array.isArray(radioGroup.properties)) {
            // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
            for (const childProperties of radioGroup.properties) {
              if (childProperties && Array.isArray(childProperties.properties)) {
                this.createItemMapById(childProperties.properties, itemMapById);
              }
            }
          }
        } else if (property.type == TemplateType.SWITCH_CHECKBOX) {
          const switchCheckbox: TemplateItemSwitchCheckbox = property as TemplateItemSwitchCheckbox;

          // 項目として出力するので、値も別途保持する
          itemMapById.set(property.id, property);

          // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
          if (switchCheckbox.properties && Array.isArray(switchCheckbox.properties)) {
            this.createItemMapById(switchCheckbox.properties, itemMapById);
          }
        }
      }

      itemMapById.set(property.id, property);
    }
  }

  /**
   * ### 要素の値を取得する
   */
  public getItemValue(item: TemplateItem, targetItem: TemplateItem): string {
    switch (item.type) {
      case TemplateType.TEXT: {
        const textItem: TemplateItemText = item as TemplateItemText;
        return textItem.answer ? textItem.answer : "";
      }
      case TemplateType.TEXTAREA: {
        const textItem: TemplateItemTextarea = item as TemplateItemTextarea;
        return `"${textItem.answer ? textItem.answer : ""}"`; // 改行コードがあるので「"」で囲う
      }
      case TemplateType.RADIO_GROUP: {
        const radioGroupItem: TemplateItemRadioGroup = item as TemplateItemRadioGroup;
        // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
        if (radioGroupItem.properties && Array.isArray(radioGroupItem.properties)) {
          for (const property of radioGroupItem.properties) {
            if (radioGroupItem.answer == property.option.value) {
              return property.option.text;
            }
          }
        }
        return "";
      }
      case TemplateType.RADIO: {
        const radioItem: TemplateItemRadio = item as TemplateItemRadio;
        for (const option of radioItem.options) {
          if (radioItem.answer == option.value) {
            return option.text;
          }
        }
        return "";
      }
      case TemplateType.SELECT: {
        const selectItem: TemplateItemSelect = item as TemplateItemSelect;
        let answers: string[] = [];
        for (const option of selectItem.options) {
          for (const answer of selectItem.answer) {
            if (answer == option.value) {
              answers.push(option.text);
            }
          }
        }
        return 0 < answers.length ? answers.join("、") : "";
      }
      case TemplateType.SWITCH_CHECKBOX: {
        const switchCheckboxitem: TemplateItemSwitchCheckbox = item as TemplateItemSwitchCheckbox;
        // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
        if (switchCheckboxitem.properties && Array.isArray(switchCheckboxitem.properties)) {
          return switchCheckboxitem.answer == true ? "はい" : "いいえ";
        }
        return "";
      }
      case TemplateType.CHECKBOX: {
        const checkboxItem: TemplateItemCheckbox = item as TemplateItemCheckbox;
        return checkboxItem.answer == true ? "はい" : "いいえ";
      }
      case TemplateType.MULTIPLE_CHECKBOX: {
        const multipleCheckboxItem: TemplateItemMultipleCheckbox = item as TemplateItemMultipleCheckbox;
        const output: string[] = [];
        for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
          if (multipleCheckboxItem.answer[i] == true) {
            output.push(multipleCheckboxItem.questions[i]);
          }
        }
        return output.join(";");
      }
      case TemplateType.ADDRESS: {
        const addressItem: TemplateItemAddress = item as TemplateItemAddress;
        // answerにundefinedを格納されている場合があるため、その場合は空文字で置換する
        if (addressItem.answer) {
          const postalCode: string = addressItem.answer.postalCode ? addressItem.answer.postalCode : "";
          const address: string = addressItem.answer.address ? addressItem.answer.address : "";
          return `${postalCode},${address}`;
        } else {
          return "";
        }
      }
      case TemplateType.BIRTHDAY: {
        const birthdayItem: TemplateItemBirthday = item as TemplateItemBirthday;
        // answerにundefinedを格納されている場合があるため、その場合は空文字で置換する
        if (birthdayItem.answer) {
          const year: string = birthdayItem.answer.year ? birthdayItem.answer.year : "";
          const month: string = birthdayItem.answer.month ? birthdayItem.answer.month : "";
          const date: string = birthdayItem.answer.date ? birthdayItem.answer.date : "";
          return `${year}年${month}月${date}日`;
        } else {
          return "";
        }
      }
      case TemplateType.YEAR_MONTH_DATE: {
        const yearMonthDateItem: TemplateItemYearMonthDate = item as TemplateItemYearMonthDate;
        // answerにundefinedを格納されている場合があるため、その場合は空文字で置換する
        if (yearMonthDateItem.answer) {
          const year: string = yearMonthDateItem.answer.year ? yearMonthDateItem.answer.year : "";
          const month: string = yearMonthDateItem.answer.month ? yearMonthDateItem.answer.month : "";
          const date: string = yearMonthDateItem.answer.date ? yearMonthDateItem.answer.date : "";
          return `${year}年${month}月${date}日`;
        } else {
          return "";
        }
      }
      case TemplateType.YEAR_MONTH: {
        const yearMonthItem: TemplateItemYearMonth = item as TemplateItemYearMonth;
        // answerにundefinedを格納されている場合があるため、その場合は空文字で置換する
        if (yearMonthItem.answer) {
          const year: string = yearMonthItem.answer.year ? yearMonthItem.answer.year : "";
          const month: string = yearMonthItem.answer.month ? yearMonthItem.answer.month : "";
          return `${year}年${month}月`;
        } else {
          return "";
        }
      }
      case TemplateType.ROOM_TYPE: {
        return this.createRoomTypeCsvValue(item as TemplateItemRoomType, targetItem as TemplateItemRoomType);
      }
      case TemplateType.FILE: {
        return ""; // ファイルは選択不可になっているが処理は作成しておく
      }
      case TemplateType.TEL: {
        const telItem: TemplateItemTel = item as TemplateItemTel;
        // answerにundefinedを格納されている場合があるため、その場合は空文字で置換する
        if (telItem.answer) {
          const first: string = telItem.answer.first ? telItem.answer.first : "";
          const second: string = telItem.answer.second ? telItem.answer.second : "";
          const third: string = telItem.answer.third ? telItem.answer.third : "";
          return `${first}－${second}－${third}`;
        } else {
          return "";
        }
      }
      case TemplateType.NAME: {
        const nameItem: TemplateItemName = item as TemplateItemName;
        // answerにundefinedを格納されている場合があるため、その場合は空文字で置換する
        if (nameItem.answer) {
          const secondName: string = nameItem.answer.secondName ? nameItem.answer.secondName : "";
          const firstName: string = nameItem.answer.firstName ? nameItem.answer.firstName : "";
          const secondKanaName: string = nameItem.answer.secondKanaName ? nameItem.answer.secondKanaName : "";
          const firstKanaName: string = nameItem.answer.firstKanaName ? nameItem.answer.firstKanaName : "";
          return `${secondName},${firstName},${secondKanaName},${firstKanaName}`;
        } else {
          return "";
        }
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 部屋種類のCSV行情報を作成する
   */
  public createRoomTypeCsvValue(item: TemplateItemRoomType, targetItem: TemplateItemRoomType): string {
    let labels: string[] = [];

    // 出力対象の部屋種類でループ
    const targetRoomTypes: Array<RoomType> = targetItem.answer as Array<RoomType>;
    for (const targetRoomType of targetRoomTypes) {
      // 待機者の保持している部屋種類でループ
      const roomTypes: Array<RoomType> = item.answer as Array<RoomType>;
      let exist: boolean = false;

      for (const roomType of roomTypes) {
        // 出力対象の施設が見つかった場合、値を格納する
        if (targetRoomType.facilityId == roomType.facilityId) {
          const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(roomType.facilityId);

          if (facility) {
            // 部屋種類回答
            if (facility.recruitmentRoom.multiBed == true) {
              labels.push(roomType.recruitmentRoom.multiBed ? "〇" : "");
            }
            if (facility.recruitmentRoom.conventinalSingle) {
              labels.push(roomType.recruitmentRoom.conventinalSingle ? "〇" : "");
            }
            if (facility.recruitmentRoom.unitTypeSingle) {
              labels.push(roomType.recruitmentRoom.unitTypeSingle ? "〇" : "");
            }
            if (facility.recruitmentRoom.single) {
              labels.push(roomType.recruitmentRoom.single ? "〇" : "");
            }
            if (facility.recruitmentRoom.double) {
              labels.push(roomType.recruitmentRoom.double ? "〇" : "");
            }

            // カスタム部屋種類回答
            if (facility.customRecruitmentRoom) {
              const customRecruitmentRoomMapById: Map<string, CustomRecruitmentRoom> = new Map<string, CustomRecruitmentRoom>();
              for (const room of facility.customRecruitmentRoom) {
                if (room.use == true) {
                  customRecruitmentRoomMapById.set(room.id, room);
                }
              }

              if (targetRoomType.customRecruitmentRoom) {
                // 施設で表示対象のカスタム部屋種類をMAP化する
                const enableCustomRecruitmentRoomMapById: Map<string, CustomRecruitmentRoom> = new Map<string, CustomRecruitmentRoom>();
                for (const room of facility.customRecruitmentRoom) {
                  if (room.use == true) {
                    enableCustomRecruitmentRoomMapById.set(room.id, room);
                  }
                }
                // 待機者の保持している部屋種類情報をMAP化する
                const customRecruitmentRoomMapById: Map<string, CustomRecruitmentRoom> = this.createCustomRecruitmentRoomMapById(roomType);
                for (const targetCustomRecruitmentRoom of targetRoomType.customRecruitmentRoom) {
                  // 施設で表示対象のカスタム部屋種類でなければスキップする
                  const enableCustomRecruitmentRoom: CustomRecruitmentRoom | undefined = enableCustomRecruitmentRoomMapById.get(targetCustomRecruitmentRoom.id);
                  if (!enableCustomRecruitmentRoom) {
                    continue;
                  }
                  // カスタム部屋種類が選択されているかを格納する
                  const customRecruitmentRoom: CustomRecruitmentRoom | undefined = customRecruitmentRoomMapById.get(targetCustomRecruitmentRoom.id);
                  if (customRecruitmentRoom) {
                    labels.push(customRecruitmentRoom.use ? "〇" : "");
                  } else {
                    labels.push("");
                  }
                }
              }
            }
            exist = true;
          }
        }
      }

      // 出力対象の施設の部屋種類が見つからなかった場合、空の値を格納する
      if (exist == false) {
        for (let i = 0; i < this.roomTypeRowCount; i++) {
          labels.push("");
        }
      }
    }

    return labels.join(",");
  }

  public createCustomRecruitmentRoomMapById(roomType: RoomType): Map<string, CustomRecruitmentRoom> {
    const customRecruitmentRoomMapById: Map<string, CustomRecruitmentRoom> = new Map<string, CustomRecruitmentRoom>();
    if (roomType.customRecruitmentRoom) {
      for (const customRecruitmentRoom of roomType.customRecruitmentRoom) {
        customRecruitmentRoomMapById.set(customRecruitmentRoom.id, customRecruitmentRoom);
      }
    }
    return customRecruitmentRoomMapById;
  }

  /**
   * ### 待機者の情報に出力対象の情報が無い(idが存在しない)場合の空値を作成する
   */
  public createEmptyItemValue(targetItem: TemplateItem): string {
    switch (targetItem.type) {
      case TemplateType.ADDRESS: {
        return ",";
      }
      case TemplateType.ROOM_TYPE: {
        return this.createRoomTypeEmptyValue(targetItem as TemplateItemRoomType);
      }
      case TemplateType.NAME: {
        return ",,,";
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 部屋種類のCSV行情報を作成する
   */
  public createRoomTypeEmptyValue(targetItem: TemplateItemRoomType): string {
    let labels: string[] = [];

    const targetRoomTypes: Array<RoomType> = targetItem.answer as Array<RoomType>;
    for (const targetRoomType of targetRoomTypes) {
      // 部屋種類回答
      for (let i = 0; i < 5; i++) {
        labels.push("");
      }
      // カスタム部屋種類回答
      if (targetRoomType.customRecruitmentRoom) {
        for (let i = 0; i < targetRoomType.customRecruitmentRoom.length; i++) {
          labels.push("");
        }
      }
    }

    return labels.join(",");
  }

  /**
   * ### 要素の値を取得する
   */
  public getItemPoint(item: TemplateItem): string {
    switch (item.type) {
      case TemplateType.TEXT: {
        const textItem: JudgeTemplateItemText = item as JudgeTemplateItemText;
        if (textItem.answer == null) {
          return "";
        } else {
          return textItem.answer;
        }
      }
      // 点数ではないが、ここで回答内容を返却する
      case TemplateType.RADIO_GROUP: {
        const radioGroupItem: TemplateItemRadioGroup = item as JudgeTemplateItemRadioGroup;
        // LIFF側でpropertiesをNULLにしてしまう場合があるため、チェックする
        if (radioGroupItem.properties && Array.isArray(radioGroupItem.properties)) {
          for (const property of radioGroupItem.properties) {
            if (radioGroupItem.answer == property.option.value) {
              return property.option.text;
            }
          }
        }
        return "";
      }
      case TemplateType.RADIO: {
        const radioItem: JudgeTemplateItemRadio = item as JudgeTemplateItemRadio;
        if (radioItem.answer == null) {
          return "";
        } else {
          for (const option of radioItem.options) {
            if (radioItem.answer == option.value) {
              return option.point ? option.point : "";
            }
          }
          return "";
        }
      }
      case TemplateType.MULTIPLE_CHECKBOX: {
        const multipleCheckboxItem: JudgeTemplateItemMultipleCheckbox = item as JudgeTemplateItemMultipleCheckbox;

        if (multipleCheckboxItem.calcType == CalcType.ADD || multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
          let point: number = 0;

          for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
            if (multipleCheckboxItem.answer[i] == true) {
              if (multipleCheckboxItem.points[i] == null) {
                continue;
              }

              // 計算種別：加算の場合は選択肢で最高得点を採用する
              if (multipleCheckboxItem.calcType == CalcType.ADD) {
                if (point < Number(multipleCheckboxItem.points[i])) {
                  point = Number(multipleCheckboxItem.points[i]);
                }
              }
              // 計算種別：計算加算の場合は選択されたpointを合算する
              else if (multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
                point += Number(multipleCheckboxItem.points[i]);
              }
            }
          }

          // 計算種別：計算加算の場合は上限までの点数とする
          if (multipleCheckboxItem.calcType == CalcType.CALC_ADD && multipleCheckboxItem.limitPoint != null && multipleCheckboxItem.limitPoint != undefined) {
            if (multipleCheckboxItem.limitPoint < point) {
              point = multipleCheckboxItem.limitPoint;
            }
          }

          return `${point}`;
        } else if (multipleCheckboxItem.calcType == CalcType.REPLACE) {
          let point: number | null = null;
          for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
            if (multipleCheckboxItem.answer[i] == true) {
              if (multipleCheckboxItem.points[i] == null) {
                continue;
              }
              if (point == null || point < Number(multipleCheckboxItem.points[i])) {
                point = Number(multipleCheckboxItem.points[i]);
              }
            }
          }

          return `${point}`;
        } else {
          return "";
        }
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 入所評価判定の合計点数を返す
   */
  public calculateJudgementPopint(admissionJudgement: AdmissionJudgement): string {
    let totalPoint: number = 0;
    let replacePoint: number | null = null;
    let points: { totalPoint: number; replacePoint: number | null } = { totalPoint, replacePoint };
    this.calculateReplacePoint(admissionJudgement.templateAnswer.properties, points);
    this.calculateTotalPoint(admissionJudgement.templateAnswer.properties, points);

    if (points.replacePoint != null) {
      return `${points.replacePoint}`;
    } else {
      return `${points.totalPoint}`;
    }
  }

  /**
   * ### 「置き換え」の点数計算を行う
   *
   * - 再帰呼び出しして入所判定テンプレートの内容を検索する
   * - 計算種別が「置き換え」のものが存在した場合、置き換え後の点数を引数のreplacePointに格納する
   * - TODO 置き換えが複数存在した場合は何を優先するのか決まっていないので検討が必要かもしれない
   *   - 今は最後に出てきたプロパティで上書きされる
   */
  public calculateReplacePoint(properties: Array<TemplateItem>, points: { totalPoint: number; replacePoint: number | null }): void {
    for (const property of properties) {
      if (property.type == TemplateType.SECTION) {
        const item: TemplateItemSection = property as TemplateItemSection;

        this.calculateReplacePoint(item.properties, points);
      } else if (property.type == TemplateType.RADIO_GROUP) {
        const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

        for (const childProperties of item.properties) {
          if (item.answer == childProperties.option.value) {
            this.calculateReplacePoint(childProperties.properties, points);
          }
        }
      } else {
        // テキスト入力
        if (property.type == TemplateType.TEXT) {
          const textItem: JudgeTemplateItemText = property as JudgeTemplateItemText;
          if (textItem.answer == null) {
            continue;
          }
          if (textItem.calcType == CalcType.REPLACE) {
            points.replacePoint = Number(textItem.answer);
          }
        }
        // ラジオ入力
        else if (property.type == TemplateType.RADIO) {
          const radioItem: JudgeTemplateItemRadio = property as JudgeTemplateItemRadio;
          if (radioItem.answer == null) {
            continue;
          }
          if (radioItem.calcType == CalcType.REPLACE) {
            for (const option of radioItem.options) {
              if (radioItem.answer == option.value) {
                points.replacePoint = option.point ? Number(option.point) : (option.point as null);
                break;
              }
            }
          }
        }
        // チェックボックス入力
        else if (property.type == TemplateType.MULTIPLE_CHECKBOX) {
          const multipleCheckboxItem: JudgeTemplateItemMultipleCheckbox = property as JudgeTemplateItemMultipleCheckbox;

          if (multipleCheckboxItem.calcType == CalcType.REPLACE) {
            let point: number | null = null;
            for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
              if (multipleCheckboxItem.answer[i] == true) {
                if (multipleCheckboxItem.points[i] == null) {
                  continue;
                }
                if (point == null || point < Number(multipleCheckboxItem.points[i])) {
                  point = Number(multipleCheckboxItem.points[i]);
                }
              }
            }

            points.replacePoint = point != null ? point : null;
          }
        }
      }
    }
    return;
  }

  /**
   * ### 「加算」の点数計算を行う
   *
   * - 再帰呼び出しして入所判定テンプレートの内容を検索する
   * - 計算種別が「加算」のものが存在した場合、点数をtotalPointに加算する
   */
  public calculateTotalPoint(properties: Array<TemplateItem>, points: { totalPoint: number; replacePoint: number | null }): void {
    for (const property of properties) {
      if (property.type == TemplateType.SECTION) {
        const item: TemplateItemSection = property as TemplateItemSection;

        this.calculateTotalPoint(item.properties, points);
      } else if (property.type == TemplateType.RADIO_GROUP) {
        const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

        for (const childProperties of item.properties) {
          if (item.answer == childProperties.option.value) {
            this.calculateTotalPoint(childProperties.properties, points);
          }
        }
      } else {
        // テキスト入力
        if (property.type == TemplateType.TEXT) {
          const textItem: JudgeTemplateItemText = property as JudgeTemplateItemText;
          if (textItem.answer == null) {
            continue;
          }
          if (textItem.calcType == CalcType.ADD || textItem.calcType == CalcType.CALC_ADD) {
            points.totalPoint += Number(textItem.answer);
          }
        }
        // ラジオ入力
        else if (property.type == TemplateType.RADIO) {
          const radioItem: JudgeTemplateItemRadio = property as JudgeTemplateItemRadio;
          if (radioItem.answer == null) {
            continue;
          }
          if (radioItem.calcType == CalcType.ADD || radioItem.calcType == CalcType.CALC_ADD) {
            for (const option of radioItem.options) {
              if (radioItem.answer == option.value) {
                points.totalPoint += Number(option.point);
              }
            }
          }
        }
        // チェックボックス入力
        else if (property.type == TemplateType.MULTIPLE_CHECKBOX) {
          const multipleCheckboxItem: JudgeTemplateItemMultipleCheckbox = property as JudgeTemplateItemMultipleCheckbox;

          if (multipleCheckboxItem.calcType == CalcType.ADD || multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
            let point: number = 0;

            for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
              if (multipleCheckboxItem.answer[i] == true) {
                if (multipleCheckboxItem.points[i] == null) {
                  continue;
                }

                // 計算種別：加算の場合は選択肢で最高得点を採用する
                if (multipleCheckboxItem.calcType == CalcType.ADD) {
                  if (point < Number(multipleCheckboxItem.points[i])) {
                    point = Number(multipleCheckboxItem.points[i]);
                  }
                }
                // 計算種別：計算加算の場合は選択されたpointを合算する
                else if (multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
                  point += Number(multipleCheckboxItem.points[i]);
                }
              }
            }

            // 計算種別：計算加算の場合は上限までの点数とする
            if (multipleCheckboxItem.calcType == CalcType.CALC_ADD && multipleCheckboxItem.limitPoint != null && multipleCheckboxItem.limitPoint != undefined) {
              if (multipleCheckboxItem.limitPoint < point) {
                point = multipleCheckboxItem.limitPoint;
              }
            }

            points.totalPoint += point;
          }
        }
      }
    }
    return;
  }

  /**
   * ### 状態と状態名を変換する
   */
  public convertStatusName(status: ResidentStatus): string {
    let statusName: string = "";

    switch (status) {
      case ResidentStatus.REGISTERD:
        statusName = "登録者";
        break;
      case ResidentStatus.CANCELED:
        statusName = "取り下げ";
        break;
      case ResidentStatus.TEMPORARILY:
        statusName = "一時保存";
        break;
      case ResidentStatus.APPLICATION:
        statusName = "入所申込み";
        break;
      case ResidentStatus.RECEIVED_APPLICATION:
        statusName = "申込み受理";
        break;
      case ResidentStatus.COMPLETE_APPLICATION:
        statusName = "判定済";
        break;
      case ResidentStatus.CONFIRM_ADMISSION:
        statusName = "入所意向確認";
        break;
      case ResidentStatus.FINAL_JUDGE:
        statusName = "最終判定中";
        break;
      case ResidentStatus.COMPLETE_FINAL_JUDGE:
        statusName = "最終判定済";
        break;
      case ResidentStatus.ADMISSION_PROCEDURE:
        statusName = "入所手続き";
        break;
      case ResidentStatus.RESIDENT:
        statusName = "利用者";
        break;
      default:
        statusName = "";
        break;
    }

    return statusName;
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });
    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    return;
  }

  /**
   * ### 待機者一覧に遷移する
   */
  public gotoWaiterList(): void {
    this.$router.push(PcUrl.WaiterList);
    return;
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      itemListFilterStore.setFilter({ url: this.$options.name, filter: this.filter });
    }
    next();
  }
}

export interface FilterSetting {
  /** 文字列検索 */
  searchWord: string;
  /** 利用者状態 */
  status: {
    /** 入所申込み */
    application: boolean;
    /** 申込み受理 */
    receivedApplication: boolean;
    /** 判定済 */
    completeApplication: boolean;
    /** 入所意向確認 */
    confirmAdmission: boolean;
    /** 最終判定中 */
    finalJudge: boolean;
    /** 最終判定済み */
    completeFinalJudge: boolean;
    /** 入所手続き */
    admissionProcedure: boolean;
    /** 取り下げ */
    canceled: boolean;
  };
  /** 性別 */
  gender: {
    /** 男性 */
    men: boolean;
    /** 女性 */
    women: boolean;
  };
  /** 部屋種類 */
  roomType: {
    /** 従来型多床室 */
    multiBed: boolean;
    /** 従来型個室 */
    conventinalSingle: boolean;
    /** ユニット型個室 */
    unitTypeSingle: boolean;
    /** 個室 */
    single: boolean;
    /** ２人部屋（夫婦部屋） */
    double: boolean;
  };
  /** 部屋種類(固有) */
  customRoomType: Array<FilterCustomRoomType>;
  /** 要介護度 */
  careLevel: {
    /** 自立 */
    careLevel1000: boolean;
    /** 申請中 */
    careLevel1010: boolean;
    /** 要支援１ */
    careLevel2010: boolean;
    /** 要支援２ */
    careLevel2020: boolean;
    /** 要介護1 */
    careLevel3010: boolean;
    /** 要介護2 */
    careLevel3020: boolean;
    /** 要介護3 */
    careLevel3030: boolean;
    /** 要介護4 */
    careLevel3040: boolean;
    /** 要介護5 */
    careLevel3050: boolean;
  };
  /** ラベル */
  labels: Array<FilterLabel>;
}
export interface FilterLabel extends WaiterLabelsGetModel {
  checked: boolean;
}
export interface FilterCustomRoomType {
  /** 識別ID */
  id: string;
  /** 名称 */
  name: string;
  /** チェック */
  value: boolean;
}
</script>

<style lang="scss" scoped>
#waiter-list-download {
  max-width: 840px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    .title {
      font-size: 22px;
      font-weight: bold;
    }
  }
  .template-title,
  .filters-title {
    font-size: 22px;
    font-weight: bold;
  }

  .waiter-label {
    margin: 2px 0;
    font-size: 12px;
    padding: 4px;
    border-radius: 0.25rem;
  }
}
</style>
